import { init as initCatalogConfigurator } from './configurator/catalog_configurator';
import { init as initVehicleConfigurator } from './vehicle_configurator/vehicle_configurator';
import { init as initRegoLookup } from './rego_lookup/rego_lookup';
import { init as initInfoPopup } from './info_popup/info_popup_view';
import { InfoPopupContainer } from '../_constants/info_popup';
import { showServicesLightbox } from '../_flux/actions/services_form_actions';
import createReactContainer from '../utilities/createReactContainer';
import { openServiceFormEvent } from '../_modules/google_analytics/services_form';
import { callToAction } from '../_modules/google_analytics/buttons';
/**
 * Renders a React component on demand
 * @author FahadNoor <fahad@tyroola.com.au>
 * @param {string} onTrigger - Html element on which click action should be triggered
 * @param {string} container - Html div in which component should be rendered
 * @param {requestCallback} initialize - init method which contains the handleView of the component
 * @param {Object=} options - Object of options passed to the react component
 * @param {requestCallback=} openAction - Action method
 * @param {requestCallback=} openActionWithFilter - Action method with filters
 * @return {void}
 */
export default (onTrigger, cb, openAction, openActionWithFilter, type, restrictCall) => {
  $('body').on('click', onTrigger, (e) => {
    e.preventDefault();
    if (!restrictCall && Object.prototype.hasOwnProperty.call(e, 'target')) {
      callToAction(e.target.innerText);
    }

    if (!type) {
      let totalExtendedFilter = 0;
      if (openActionWithFilter) {
        $.each($(this).data(), () => {
          totalExtendedFilter += 1;
        });
      }
      if (totalExtendedFilter > 0) {
        openActionWithFilter($(this).data());
      } else {
        openAction();
      }
      cb();
    } else {
      openAction(e);
      cb(e.currentTarget.href);
    }
  });
};

export const initializeConfiguratorComponents = (options = {}, configurator = false) => {
  const { catalogContainer, regoContainer, vehicleContainer } = options;
  const CONFIGURATOR_CONTAINER_ID = catalogContainer || 'configurator';
  const VEHICLE_CONFIGURATOR_CONTAINER_ID = vehicleContainer || 'vehicle-configurator';
  const REGO_LOOKUP_CONTAINER_ID = regoContainer || 'rego-lookup-configurator';
  if (configurator) {
    initCatalogConfigurator(document.getElementById(CONFIGURATOR_CONTAINER_ID), options);
    initInfoPopup(document.getElementById(InfoPopupContainer), {});
  }
  initVehicleConfigurator(document.getElementById(VEHICLE_CONFIGURATOR_CONTAINER_ID), options);
  initRegoLookup(document.getElementById(REGO_LOOKUP_CONTAINER_ID), options);
};

export const initServicesForm = () => {
  import(/* webpackChunkName: "services" */ './services_form').then((component) => {
    createReactContainer(component.init, 'services-form-container', showServicesLightbox);
    openServiceFormEvent();
  });
};
